import { render, staticRenderFns } from "./index--status.vue?vue&type=template&id=e48cc490&scoped=true&"
import script from "./index--status.vue?vue&type=script&lang=js&"
export * from "./index--status.vue?vue&type=script&lang=js&"
import style0 from "./index--status.vue?vue&type=style&index=0&id=e48cc490&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48cc490",
  null
  
)

export default component.exports